let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("kBiYE")]).then(() => parcelRequire('2H2FV'));